import PropTypes from 'prop-types';
import React from 'react';

const EmailLink = ({ email, children, ...props }) =>
  <a href={`mailto:${email}`} {...props}>{children}</a>;

EmailLink.propTypes = {
  email: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default EmailLink;



// WEBPACK FOOTER //
// ./client/app/shared/components/EmailLink/index.jsx